import { Outlet } from "react-router-dom";
import useLocalStorage from "../../hooks/useLocalStorage";
import RedCactus from './../../pages/redcactus/RedCactus';
import { useLocation } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import React, { Suspense } from "react";
import LoadingOverlay from "../LoadingOverlay";
import { ErrorBoundary } from "react-error-boundary";
import fallbackRender from "../ErrorBoundary";

const Header = React.lazy(()=>import("./Header"));
const Footer = React.lazy(()=>import("./Footer"));
const Layout: React.FC = () => {
  const [userBehaviourTracking, setUserBehaviourTracking] = useLocalStorage<
    string | undefined
    >("UserBehaviourTracking", undefined);
  const location = useLocation();
  const auth = useAuth();
  return (
    <div
      className={`container-fluid px-0 h-100 ${
        userBehaviourTracking ? "" : "mBottom70"
      }`}
    >
      <div className="row no-gutters h-100">
        <div className="col-md-12 h-100">
           <ErrorBoundary FallbackComponent={fallbackRender}><Suspense fallback= {<div><LoadingOverlay
                                customStyle={{ position: "fixed", marginTop: "55px" }}
                                themeColor={"light"}
                                size={"medium"}
                                loadingText={""}
                              /></div>}>
          <Header />
          </Suspense></ErrorBoundary>
          <Outlet />
           <ErrorBoundary FallbackComponent={fallbackRender}><Suspense fallback= {<div><LoadingOverlay
                      customStyle={{ position: "fixed", marginTop: "55px" }}
                      themeColor={"light"}
                      size={"medium"}
                      loadingText={""}
                    /></div>}>
          <Footer></Footer>
         {auth?.accessToken &&
          auth?.userPermissions &&
          !location.pathname.includes("/login") &&
          !location.pathname.includes("/customer-platform") && (
            <RedCactus />
          )}
 </Suspense></ErrorBoundary>
   </div>
      </div>
    </div>
  );
};

export default Layout;
